import { render, staticRenderFns } from "./DiagramEditor.vue?vue&type=template&id=0c333e9c&scoped=true&"
import script from "./DiagramEditor.vue?vue&type=script&lang=js&"
export * from "./DiagramEditor.vue?vue&type=script&lang=js&"
import style0 from "./DiagramEditor.vue?vue&type=style&index=0&id=0c333e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c333e9c",
  null
  
)

export default component.exports